<template>
  <div class="sysNotice-operation-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span v-if="$route.query.id">编辑</span>
        <span v-else>新增</span>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'sysNotice' })"
        >
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="save">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="100px"
          @submit.native.prevent
          :model="formData"
          ref="ruleForm"
          label-position="top"
          :rules="rules"
        >
          <el-form-item label="标题" prop="title">
            <el-input v-model="formData.title"></el-input>
          </el-form-item>
          <el-form-item label="客户端类型" prop="clientType">
            <el-checkbox-group v-model="formData.clientType">
              <el-checkbox
                v-for="item in clientTypeOpts"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="是否弹窗通知">
            <el-radio v-model="formData.isNeedPopup" :label="true">是</el-radio>
            <el-radio v-model="formData.isNeedPopup" :label="false">否</el-radio>
          </el-form-item>
          
          <el-form-item label="截止日期" prop="date">
            <el-date-picker
              v-model="date"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="截止时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Mac(多种Mac用\隔开)" prop="mac">
            <el-input v-model="formData.mac"></el-input>
          </el-form-item>
          <el-form-item label="型号(多种型号用\隔开)" prop="model">
            <el-input v-model="formData.model"></el-input>
          </el-form-item>
          <el-form-item label="设备型号组" prop="modelGroups">
            <el-checkbox-group v-model="formData.modelGroups">
              <el-checkbox
                v-for="item in modelData"
                :key="item._id"
                :label="item._id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="描述内容">
            <editor
              api-key="j9xdmm7yklb7mhgzd47u5biiqnnx621qcgm9vta30ejwd4ow"
              v-model="formData.description"
              :init="{
                height: 500,
                menubar: true,
                language: 'zh_CN',
                font_formats:
                  '微软雅黑=Microsoft YaHei;黑体=STHeiti;宋体=simsun;仿宋=STFangsong;新宋体=NSimSun;楷体=KaiTi;隶书=LiSu;幼圆=YouYuan;行楷=STXingkai;姚体=FZYaoti;新魏=STXinwei',
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount',
                ],
                file_picker_types: 'image media',
                file_picker_callback: handleUpload,
                toolbar:
                  'undo redo | formatselect | bold italic underline forecolor backcolor fontsizeselect | \
                               alignleft aligncenter alignright alignjustify | \
                               bullist numlist outdent indent | \
                               image media | link unlink | table removeformat',
              }"
            />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import OSS from "ali-oss";
import { mapGetters } from "vuex";

export default {
  components: {
    editor: Editor,
  },
  computed: {
    ...mapGetters(["buckets"]),
  },
  data() {
    return {
      formData: {
        title: "",
        model: "",
        isNeedPopup: false,
        mac: "",
        public: 1,
        description: "",
        modelGroups: [],
        clientType: [],
      },
      params: {},
      modelData: [],
      rules: {},
      date: [],
      clientTypeOpts: [
        {
          value: "web",
          label: "WEB端",
        },
        {
          value: "pc",
          label: "PC端",
        },
        {
          value: "android",
          label: "Android",
        },
        {
          value: "ios",
          label: "IOS",
        },
        {
          value: "mira",
          label: "显示器",
        },
        {
          value: "device",
          label: "设备",
        },
      ],
    };
  },
  methods: {
    async getSysNoticeDetails() {
      let res = await this.$http.getSysNoticeDetails(this.$route.query.id);
      res.data.model = res.data.model.join("\\");
      res.data.mac = res.data.mac.join("\\");
      if (res.data.startAt !== null && res.data.endAt !== null) {
        this.date = [res.data.startAt, res.data.endAt];
      }
      this.formData = Object.assign(this.formData, res.data);
    },

    getModelGroups() {
      this.$http.getModelGroups().then((res) => {
        this.modelData = res.data.results;
      });
    },

    save() {
      this.params = Object.assign({}, this.formData);
      this.params.model = this.params.model
        .split("\\")
        .filter((item) => item && item.trim());
      this.params.mac = this.params.mac
        .split("\\")
        .filter((item) => item && item.trim());
      if (this.date !== null) {
        this.params.startAt = this.date[0];
        this.params.endAt = this.date[1];
      } else {
        this.params.startAt = null;
        this.params.endAt = null;
      }

      if (this.$route.query.id) {
        this.edit();
      } else {
        this.create();
      }
    },

    async create() {
      await this.$http.createSysNotice(this.params);
      this.elMsg("操作成功", "success");
      this.$router.push({ name: "sysNotice" });
    },

    async edit() {
      await this.$http.updateSysNotice(this.$route.query.id, this.params);
      this.elMsg("操作成功", "success");
      this.$router.push({ name: "sysNotice" });
    },

    handleUpload(callback, value, meta) {
      //创建一个隐藏的type=file的文件选择input
      let input = document.createElement("input"); //创建一个隐藏的input
      input.setAttribute("type", "file");

      if (meta.filetype == "media") {
        // 上传视频
        input.onchange = async (e) => {
          let file = e.target.files[0];
          let url = await this.uploadFile(file, "media");
          callback(url);
        };
      } else if (meta.filetype == "image") {
        input.onchange = async (e) => {
          let file = e.target.files[0];
          let url = await this.uploadFile(file, "image");
          callback(url);
        };
      }
      //触发点击
      input.click();
    },

    async uploadFile(file, type) {
      let { bucket } = this.buckets["onyx-static"];
      let fileObj = await this.uploadOss(file, bucket, "neocloud_admin");
      return fileObj.url;
    },

    uploadOss(file, bucket, key) {
      return new Promise(async (resolve, reject) => {
        try {
          let sts = await this.$http.aliyunSts();
          let { region } = this.buckets["onyx-static"];
          let client = await new OSS({
            region,
            accessKeyId: sts.data.AccessKeyId,
            accessKeySecret: sts.data.AccessKeySecret,
            stsToken: sts.data.SecurityToken,
            bucket,
            secure: true,
          });
          let coverData = await client.multipartUpload(
            `${key}/${file.name}`,
            file,
            {
              progress: (p, cpt, res) => {
                this.progress = Number((p * 100).toFixed(2));
              },
            }
          );

          resolve({
            key: coverData.name,
            bucket,
            name: file.name,
            url: coverData.res.requestUrls[0].split("?")[0],
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    random_string(len) {
      len = len || 32;
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
  },
  mounted() {
    this.getModelGroups();
    if (this.$route.query.id) {
      this.getSysNoticeDetails();
    }
  },
};
</script>

<style lang="scss">
.sysNotice-operation-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
    }
    .pic {
      .pic-item {
        /* position: relative; */
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }
      .global-button-style {
        width: 80px;
        height: 30px;
      }
      .sysNotice-operation-edit-cover {
        position: relative;
        width: 200px;
        height: 300px;
        overflow: hidden;
        margin: 10px 0;
        border: 2px dashed #ccc;
        border-radius: 10px;
        &:hover {
          border-color: #bb745c;
        }
        > img {
          width: 100%;
          height: 100%;
        }
        > .sysNotice-operation-edit-cover-icon {
          font-weight: bold;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #bb745c;
        }
        > .sysNotice-operation-edit-upload {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          transition: all 0.2s;
          &:hover {
            transition: all 0.2s;
            background: rgba($color: #000000, $alpha: 0.4);
            .sysNotice-operation-edit-upload-btn {
              display: block;
            }
          }
          .sysNotice-operation-edit-upload-btn {
            width: 100%;
            height: 100%;
            display: none;
            cursor: pointer;
            color: #fff;
            font-weight: bold;
            position: absolute;
            text-align: center;
            line-height: 300px;
            > .el-upload--text {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .add-img {
        width: 70px;
        height: 40px;
        font-size: 22px;
        line-height: 43px;
        color: #fff;
        cursor: pointer;
        background-color: #bb745c;
      }
    }
  }
}
</style>
